import React, { lazy, Suspense } from "react";
import { APP_ROUTES, APP_ROUTES_LABEL } from "../../constants/appConstants";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { labelsPageData } from "../../constants/navigationConfig";

// Page components
const ImpactTracking = lazy(() => import("./ImpactTracking"));
const InstitutionalVariation = lazy(() => import("./InstituitonalVariation"));
const DataQuality = lazy(() => import("./DataQuality"));
const PatientTracking = lazy(() => import("./PatientTracking"));
const UnmetNeedDefinition = lazy(() => import("./UnmetNeedDefinition"));
const PriorityEngagement = lazy(() => import("../PriorityEngagement"));
const HcpInsight = lazy(() => import("./HcpInsights"));
const MedicalAffairToolbox = lazy(() => import("./MedicalAffairsToolbox"));
const PayerVariation = lazy(() => import("./PayerVariation"));
const PatientOpportunityPage = lazy(() => import("../PatientOpportunityPage"));
const PhysicianCareProfile = lazy(() => import("../PhysicianCareProfile"));
const GeographicUnmetNeed = lazy(() => import("../GeographicUnmetNeed"));
const TargetList = lazy(() => import("./TargetLists"));
const Settings = lazy(() => import("../Settings"));
const Testing = lazy(() => import("../Testing"));

// Page component mapping
const pageComponents = {
  [APP_ROUTES.patient_journey]: PatientTracking,
  [APP_ROUTES.patient_opportunity_mapping_and_strategy]: PatientOpportunityPage,
  [APP_ROUTES.priority_engagement_opportunity_page]: PriorityEngagement,
  [APP_ROUTES.data_quality]: DataQuality,
  [APP_ROUTES.hcp_insights]: HcpInsight,
  [APP_ROUTES.eligible_patient_locator]: PhysicianCareProfile,
  [APP_ROUTES.geographic_unmet_need]: GeographicUnmetNeed,
  [APP_ROUTES.target_lists]: TargetList,
  [APP_ROUTES.payer_variation]: PayerVariation,
  [APP_ROUTES.institutional_variation]: InstitutionalVariation,
  [APP_ROUTES.medical_affair_toolbox]: MedicalAffairToolbox,
  [APP_ROUTES.testing]: Testing,
  [APP_ROUTES.impact_tracking]: ImpactTracking,
  [APP_ROUTES.unmet_need_definition]: UnmetNeedDefinition,
  [APP_ROUTES.settings]: Settings,
};

const Output = () => {
  const { currentMenu, isProfileOpen } = useSelector((state) => state.menu);
  const { id } = useParams();

  // Get the component for the current menu
  const PageComponent = pageComponents[currentMenu];

  return (
    <>
      {isProfileOpen && (
        <>
          <h1 className="text-xl font-[500]">{APP_ROUTES_LABEL[id]}</h1>
          <p className="text-sm mb-10">
            {labelsPageData[id]?.description || ""}
          </p>
        </>
      )}
      <Suspense fallback={<div role="status" className="p-4">Loading page…</div>}>
        {PageComponent && <PageComponent />}
      </Suspense>
    </>
  );
};

export default Output;
